<div class="modal-wrapper">
  <hospitality-bot-dialog-header
    [title]="heading"
    [icon]="isAllowancePopup ? 'pi pi-percentage' : 'pi pi-undo'"
    (onClose)="close()"
  ></hospitality-bot-dialog-header>

  <div class="modal-body" [formGroup]="userForm">
    <p class="modal-lead" *ngIf="serviceName">
      Apply an allowance on <b>{{ serviceName }}</b>.
    </p>

    <!-- Item Amount Summary Card -->
    <div class="amount-summary-card" *ngIf="maxAmount !== undefined && maxAmount !== null">
      <div class="amount-row">
        <span class="amount-label">Charge Amount:</span>
        <b class="amount-val">{{ maxAmount | dynamicCurrency }}</b>
      </div>
    </div>

    <div class="form-row">
      <!-- Amount Input for Default & Allowance Popups -->
      <hospitality-bot-input
        class="half-width"
        *ngIf="!isReservationPopup"
        controlName="refundAmount"
        label="Amount *"
        [props]="{
          type: 'number',
          placeholder: 'Enter amount',
          errorMessages: {
            max: 'Amount cannot exceed item value'
          }
        }"
        [max]="maxAmount"
      ></hospitality-bot-input>

      <!-- Amount Input for Reservation Popup -->
      <div class="half-width" *ngIf="isReservationPopup">
        <hospitality-bot-input
          #chargedAmount
          controlName="chargedAmount"
          label="Charged Amount *"
          [props]="{
            type: 'number',
            placeholder: 'Enter amount'
          }"
        ></hospitality-bot-input>
        <span class="charges-info">Exclusive of Taxes</span>
      </div>

      <hospitality-bot-option-checkbox-group
        class="half-width"
        *ngIf="isTaxInclusiveVisible"
        controlName="inclusiveTax"
        label="Tax"
      ></hospitality-bot-option-checkbox-group>

      <!-- Select Tax Multi-Select Dropdown -->
      <hospitality-bot-multi-select
        class="half-width"
        *ngIf="isTaxDropdown"
        controlName="tax"
        label="Select Tax"
        [options]="taxDropdownOptions"
      ></hospitality-bot-multi-select>
    </div>

    <!-- Remarks Field -->
    <hospitality-bot-text-area
      class="full-width"
      controlName="remarks"
      label="Remarks *"
      [props]="{
        placeholder: 'Enter remarks or reason',
        maxLength: 200
      }"
    ></hospitality-bot-text-area>

    <hospitality-bot-info-note
      *ngIf="isAllowancePopup"
      type="info"
      text="Attached taxes will be automatically recalculated based on the adjusted charge."
    ></hospitality-bot-info-note>
  </div>

  <div class="modal-footer">
    <hospitality-bot-button
      label="Cancel"
      (onClick)="close()"
      variant="outlined"
    ></hospitality-bot-button>
    <hospitality-bot-button
      [label]="isAllowancePopup ? 'Apply Allowance' : 'Apply'"
      (onClick)="handleApply()"
    ></hospitality-bot-button>
  </div>
</div>
